"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SubInformation_1 = require("./SubInformation");
function convertToLocaleDate(source) {
    return (new Date(source)).toLocaleDateString();
}
function formatDate(source) {
    var date = convertToLocaleDate(source);
    if (date !== "Invalid Date") {
        return date;
    }
    var timeStamp = parseInt(source, 10) * 1000;
    if (Date.parse("1993-04-30") < timeStamp && timeStamp < Date.now()) {
        return convertToLocaleDate(timeStamp);
    }
    // If source is not too long, it should represent a date.
    if (source.length < 30) {
        return source;
    }
    return null;
}
exports.formatDate = formatDate;
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        var _a = this.props, label = _a.label, value = _a.value;
        var date = formatDate(value);
        if (!date) {
            return false;
        }
        return React.createElement(SubInformation_1.default, null,
            label,
            ": ",
            date);
    };
    return default_1;
}(React.Component));
exports.default = default_1;



//////////////////
// WEBPACK FOOTER
// ./src/component/LabeledDate.tsx
// module id = 89
// module chunks = 0